// Backend errors arrive as { error: { code, message } } on the axios error.
export const apiErrorMessage = (err: any, fallback: string): string =>
  err?.response?.data?.error?.message ||
  err?.response?.data?.message ||
  err?.error?.message ||
  fallback;
